export default __webpack_public_path__ + "static/media/GEN_About_Content_01.e8d88f31.jpg";